export const QUERY__REFERRALS = 'referrals';
